import * as React from 'react';
import DentistItemComponent from './dentist-item';
import { IAAPDDentist } from '../classes/dentist';
import { FindAPDAppState } from '../classes/redux-states';
import { connect, Dispatch } from 'react-redux';
import { getDentists, getSettings } from '../redux/actions/find-a-dentist-api';
import { FindAPDSettingsModel } from "../redux/reducers/find-a-pd-settings";


interface StateToProps {
    dentists: any[];
    state: FindAPDAppState;
    totalDentists: number;
    settings: FindAPDSettingsModel;
    totalPages: number
}

interface DispatchToProps {
    getDentists: (page: number) => any;
    getSettings: () => any;
}

type DentistListProps = StateToProps & DispatchToProps;

export class DentistListComponent extends React.Component<DentistListProps, null> {
    constructor(props: DentistListProps) {
        super(props);
        this.props.getSettings();
    }

    currentResultsNumber() {
        let pageSize = this.props.state.findAPDFiltersModel.pageSize;

        if (this.props.totalDentists == 0)
            return "0"
        if (this.props.state.findAPDPaginationModel.currentPage * pageSize > this.props.totalDentists) {
            return (((this.props.state.findAPDPaginationModel.currentPage - 1) * pageSize) + 1).toString() + "-" + this.props.totalDentists.toString();
        }
        else if (this.props.totalDentists == 1) {
            return "1";
        }
        else {
            return (((this.props.state.findAPDPaginationModel.currentPage - 1) * pageSize) + 1).toString() + "-" + (this.props.state.findAPDPaginationModel.currentPage * pageSize).toString();
        }
    }

    noResultsStatus() {
        if (this.props.state.findAPDApiModel.initialLoad == true)
            return false;
        else if (this.props.state.findAPDApiModel.initialLoad == false) {
            if (this.props.dentists.length == 0) {
                return true;
            }
            else return false;
        }
        else return false;
    }

    render() {
        return (
            <div className="find-a-pd-results-container" data-find-a-pd-results>
                <div className="find-a-pd-results-info-container">
                    <div className="find-a-pd-results-info-message">
                        <p>Showing {this.currentResultsNumber()} of {this.props.totalDentists} Results </p>
                    </div>

                    <div className="find-a-pd-results-info-links">
                        <a href={this.props.settings.disclaimerLink}> Disclaimer & Acceptance</a>

                        {
                            (!this.noResultsStatus() && this.currentResultsNumber() !== "0") ?
                                <button className="btn-reset find-a-pd-results-print-trigger" onClick={() => (window as any).print()} title="print">
                                    <svg className="svg-icon svg-icon-inline" aria-hidden="true" focusable="false">
                                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-printer" />
                                    </svg>
                                    <span className="visually-hidden">Print</span>
                                </button> : null
                        }
                    </div>
                </div>

                <ul className="find-a-pd-results-list">
                    {
                        this.props.dentists.map(dentist => <DentistItemComponent dentist={dentist} key={this.props.dentists.indexOf(dentist)} />)
                    }
                </ul>

                {
                    this.noResultsStatus() ?
                        <div className="find-a-pd-no-results-container">
                            <h4>We couldn't find any results that match your search.</h4>
                        </div> : null

                }

            </div>
        )
    }
}

function mapStateToProps(state: FindAPDAppState): StateToProps {
    return {
        dentists: state.findAPDApiModel.dentistList || [],
        state: state,
        totalDentists: state.findAPDApiModel.totalDentists,
        settings: state.findAPDSettingsModel,
        totalPages: state.findAPDApiModel.totalPages
    }
}

function mapDispatchToProps(dispatch: Dispatch<FindAPDAppState>): DispatchToProps {
    return {
        getDentists: (page: number) => dispatch(getDentists(page)),
        getSettings: () => dispatch(getSettings())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DentistListComponent)


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/components/dentist-list.tsx